// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RequestCard_container__lv0lh{
    width: calc(100% - 36px);
    margin-top: 15px;
    padding: 15px 18px;
    border: 1px solid #1F363D1A;
    border-radius: 25px;
    box-shadow: 0 3px 12px 0 #00000012;
}
.RequestCard_firstRow__R0FKS, .RequestCard_secondRow__18ScY, .RequestCard_thirdRow__PS6uF{
    display: flex;
}
.RequestCard_firstRow__R0FKS{
    align-items: center;
}
.RequestCard_organizerPicture__nCAeE{
    height: 36px;
    width: 36px;
    margin-right: 10px;
    border-radius: 500px;
}
.RequestCard_organizerPlaceholder__Kdh23{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 36px;
    width: 36px;
    margin-right: 10px;
    color: #578E86;
    background-color: #BFE1DC;
    font-size: 12px;
    font-family: 'Gotham Medium', serif;
    border-radius: 50%;
    letter-spacing: -2px;
}
.RequestCard_organizerName__srvHT{
    color: #1F363D;
    font-size: 14px;
    font-family: 'Gotham Medium', serif;
}
@media(min-width: 701px) and (max-width: 860px), (max-width: 530px){
    .RequestCard_organizerName__srvHT{
        margin-right: 15px;
    }
}
.RequestCard_createdAt__ggGDs{
    margin-left: auto;
    font-size: 12px;
    color: #1F363D99;
}
.RequestCard_secondRow__18ScY{
    margin-top: 15px;
}
.RequestCard_name__7CdUh{
    color: #40798C;
    font-size: 16px;
    font-family: 'Gotham Bold', serif;
    text-decoration: none;
}
.RequestCard_thirdRow__PS6uF{
    display: flex;
    align-items: center;
    margin-top: 20px;
}
@media(min-width: 701px) and (max-width: 860px), (max-width: 530px){
    .RequestCard_thirdRow__PS6uF.RequestCard_requested__0iCfh{
        display: block;
    }
}
.RequestCard_dollarCircle__7DJBM{
    position: relative;
    top: 1.5px;
    height: 14px;
    width: 14px;
    margin-right: 5px;
}
.RequestCard_goalLabel__hxJo4{
    margin-right: 5px;
    color: #1F363D80;
    font-size: 14px;
}
.RequestCard_goalAmount__gTS8u{
    color: #1F363D;
    font-size: 14px;
    font-family: 'Gotham Medium', serif;
}
.RequestCard_buttons__Pvf2P, .RequestCard_status__yAob1{
    margin-left: auto;
}
.RequestCard_buttons__Pvf2P{
    display: flex;
}
@media(min-width: 701px) and (max-width: 860px), (max-width: 530px){
    .RequestCard_buttons__Pvf2P{
        justify-content: center;
        margin-top: 20px;
        margin-left: 0;
    }
}
.RequestCard_rejectButton__xm8MF, .RequestCard_approveButton__QCiBv{
    height: 38px;
    width: 150px;
}
.RequestCard_rejectButton__xm8MF{
    color: #EB443F;
    margin-right: 10px;
    border-color: #EB443F66;
}
.RequestCard_status__yAob1{
    font-size: 14px;
    color: #1F363D80;
}
.RequestCard_status__yAob1.RequestCard_approved__FGCRr, .RequestCard_status__yAob1.RequestCard_rejected__\\+XstD{
    font-size: 14px;
    font-family: 'Gotham Medium', serif;
}
.RequestCard_status__yAob1.RequestCard_approved__FGCRr{
    color: #29A462;
}
.RequestCard_status__yAob1.RequestCard_rejected__\\+XstD{
    color: #EB443F;
}
.RequestCard_checkmarkCircleGreen__wUija, .RequestCard_xCircleRed__1ZDY0{
    position: relative;
    top: 3.5px;
    height: 16px;
    width: 16px;
    margin-right: 7px;
}
@media(max-width: 700px){
    .RequestCard_checkmarkCircleGreen__wUija, .RequestCard_xCircleRed__1ZDY0{
        top: 3px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/profile/RequestCard.module.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,mCAAmC;IACnC,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,cAAc;IACd,eAAe;IACf,mCAAmC;AACvC;AACA;IACI;QACI,kBAAkB;IACtB;AACJ;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;IACf,iCAAiC;IACjC,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI;QACI,cAAc;IAClB;AACJ;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,cAAc;IACd,eAAe;IACf,mCAAmC;AACvC;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;AACjB;AACA;IACI;QACI,uBAAuB;QACvB,gBAAgB;QAChB,cAAc;IAClB;AACJ;AACA;IACI,YAAY;IACZ,YAAY;AAChB;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,mCAAmC;AACvC;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;AACA;IACI;QACI,QAAQ;IACZ;AACJ","sourcesContent":[".container{\n    width: calc(100% - 36px);\n    margin-top: 15px;\n    padding: 15px 18px;\n    border: 1px solid #1F363D1A;\n    border-radius: 25px;\n    box-shadow: 0 3px 12px 0 #00000012;\n}\n.firstRow, .secondRow, .thirdRow{\n    display: flex;\n}\n.firstRow{\n    align-items: center;\n}\n.organizerPicture{\n    height: 36px;\n    width: 36px;\n    margin-right: 10px;\n    border-radius: 500px;\n}\n.organizerPlaceholder{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 36px;\n    width: 36px;\n    margin-right: 10px;\n    color: #578E86;\n    background-color: #BFE1DC;\n    font-size: 12px;\n    font-family: 'Gotham Medium', serif;\n    border-radius: 50%;\n    letter-spacing: -2px;\n}\n.organizerName{\n    color: #1F363D;\n    font-size: 14px;\n    font-family: 'Gotham Medium', serif;\n}\n@media(min-width: 701px) and (max-width: 860px), (max-width: 530px){\n    .organizerName{\n        margin-right: 15px;\n    }\n}\n.createdAt{\n    margin-left: auto;\n    font-size: 12px;\n    color: #1F363D99;\n}\n.secondRow{\n    margin-top: 15px;\n}\n.name{\n    color: #40798C;\n    font-size: 16px;\n    font-family: 'Gotham Bold', serif;\n    text-decoration: none;\n}\n.thirdRow{\n    display: flex;\n    align-items: center;\n    margin-top: 20px;\n}\n@media(min-width: 701px) and (max-width: 860px), (max-width: 530px){\n    .thirdRow.requested{\n        display: block;\n    }\n}\n.dollarCircle{\n    position: relative;\n    top: 1.5px;\n    height: 14px;\n    width: 14px;\n    margin-right: 5px;\n}\n.goalLabel{\n    margin-right: 5px;\n    color: #1F363D80;\n    font-size: 14px;\n}\n.goalAmount{\n    color: #1F363D;\n    font-size: 14px;\n    font-family: 'Gotham Medium', serif;\n}\n.buttons, .status{\n    margin-left: auto;\n}\n.buttons{\n    display: flex;\n}\n@media(min-width: 701px) and (max-width: 860px), (max-width: 530px){\n    .buttons{\n        justify-content: center;\n        margin-top: 20px;\n        margin-left: 0;\n    }\n}\n.rejectButton, .approveButton{\n    height: 38px;\n    width: 150px;\n}\n.rejectButton{\n    color: #EB443F;\n    margin-right: 10px;\n    border-color: #EB443F66;\n}\n.status{\n    font-size: 14px;\n    color: #1F363D80;\n}\n.status.approved, .status.rejected{\n    font-size: 14px;\n    font-family: 'Gotham Medium', serif;\n}\n.status.approved{\n    color: #29A462;\n}\n.status.rejected{\n    color: #EB443F;\n}\n.checkmarkCircleGreen, .xCircleRed{\n    position: relative;\n    top: 3.5px;\n    height: 16px;\n    width: 16px;\n    margin-right: 7px;\n}\n@media(max-width: 700px){\n    .checkmarkCircleGreen, .xCircleRed{\n        top: 3px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RequestCard_container__lv0lh`,
	"firstRow": `RequestCard_firstRow__R0FKS`,
	"secondRow": `RequestCard_secondRow__18ScY`,
	"thirdRow": `RequestCard_thirdRow__PS6uF`,
	"organizerPicture": `RequestCard_organizerPicture__nCAeE`,
	"organizerPlaceholder": `RequestCard_organizerPlaceholder__Kdh23`,
	"organizerName": `RequestCard_organizerName__srvHT`,
	"createdAt": `RequestCard_createdAt__ggGDs`,
	"name": `RequestCard_name__7CdUh`,
	"requested": `RequestCard_requested__0iCfh`,
	"dollarCircle": `RequestCard_dollarCircle__7DJBM`,
	"goalLabel": `RequestCard_goalLabel__hxJo4`,
	"goalAmount": `RequestCard_goalAmount__gTS8u`,
	"buttons": `RequestCard_buttons__Pvf2P`,
	"status": `RequestCard_status__yAob1`,
	"rejectButton": `RequestCard_rejectButton__xm8MF`,
	"approveButton": `RequestCard_approveButton__QCiBv`,
	"approved": `RequestCard_approved__FGCRr`,
	"rejected": `RequestCard_rejected__+XstD`,
	"checkmarkCircleGreen": `RequestCard_checkmarkCircleGreen__wUija`,
	"xCircleRed": `RequestCard_xCircleRed__1ZDY0`
};
export default ___CSS_LOADER_EXPORT___;
